/** Normalize provider redirects before Angular's initial navigation can run. */
export function normalizeOAuthCallbackUrl(
	location: Pick<Location, "pathname" | "hash" | "search" | "origin"> = window.location,
	history: Pick<History, "state" | "replaceState"> = window.history,
): boolean {
	const match = /\/(?:auth\/)?(google|github|linkedin|microsoft)-callback$/i.exec(location.pathname);
	if (!match) {
		return false;
	}

	const callbackPath = `/auth/${match[1].toLowerCase()}-callback`;
	if (location.hash.toLowerCase().startsWith(`#${callbackPath}`)) {
		return false;
	}

	// Replace in place: a reload would let the protected root route clear OAuth
	// session state before the browser finishes navigating to the callback.
	history.replaceState(history.state, "", `${location.origin}/#${callbackPath}${location.search}`);
	return true;
}
